<template>
  <div class="animated">
    <modal-trash-basket
      v-if="checkPermission('delete attribute list')"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-client-table
      :columns="columns"
      :data="currentAttributesList"
      :options="options"
      :theme="theme"
      id="attribute-list-table"
      class="w-100"
    >
      <div v-if="parent" slot="beforeTable" class="pt-3">
        <b-row>
          <b-col>
            <add-on-select
              :options="parentAttributesList"
              :selectedOption="selectedParent"
              :customPlaceholder="'Select parent Attribute List'"
              :isMultiple="false"
              :hideTitle="true"
              @onAddOnSelect="onSelect"
            />
          </b-col>
        </b-row>
      </div>
      <span slot="name" slot-scope="{ row }">
        {{ row.value }}
      </span>
      <span slot="sub_attributes" slot-scope="{ row }">
        {{ row.children.length || "--" }}
      </span>
      <template slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit attribute list')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/attributes-lists/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete attribute list')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import AddOnSelect from "../../../../.archived/submissionwizard/components/misc/AddOnSelect";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import { mapActions, mapGetters } from "vuex";
import { ClientTable } from "vue-tables-2";
import { AccessControlCheck } from "@/auth/AccessControlCheck"

Vue.use(ClientTable);

export default {
  name: "AttributesListTable",
  components: {
    AddOnSelect,
    ClientTable,
    HeaderButtonGroup,
    ModalTrashBasket
  },
  props: {
    attributeList: {
      type: Array
    },
    parentAttributesList: {
      type: Array
    },
    show_columns: {
      type: Array,
      default: () => ["name", "sub_attributes", "actions"]
    },
    parent: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      entity_type: "attributeLists",
      data: this.attributeList,
      selectedParent: null,
      options: {
        headers: {
          name: "Name",
          sub_attributes: "Sub-Attributes",
          actions: "Actions"
        },
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        filterable: false
      },
      theme: "bootstrap4",
      template: "default"
    };
  },
  computed: {
    ...mapGetters({
      trash: "attributeListsTrash",
      parent_id: "parentId"
    }),
    currentAttributesList() {
      return (
        (this.parent &&
          this.attributeList.filter(item => {
            if (this.selectedParent)
              return item.parent && item.parent.id === this.selectedParent;
            return !item.parent;
          })) ||
        this.attributeList
      );
    },
    columns() {
      const actions_access = this.checkPermission("edit attribute list")
        || this.checkPermission("delete attribute list");
 
      return actions_access
        ? this.show_columns
        : this.show_columns.filter(column => column !== "actions")
    }
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    onSelect(value) {
      this.selectedParent = (value && value.id) || null;
    },
    isDeleted(id) {
      return this.trash.find(item => item.id === id);
    },
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    onUpdate() {
      this.$router.push("/managed-lists");
    }
  }
};
</script>
